import { Component, OnInit } from '@angular/core';
import { TranslationManager } from 'src/common/translation';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

    translationManager = TranslationManager;
	
	public static instance: SpinnerComponent = new SpinnerComponent();
	private showCounter: number = 0;
	private timeout: any;

	public showSpinner: boolean = false;
	public showSpinnerBlock: boolean = false;

	public set show(value: boolean) {
		if (value) {
			this.showCounter++;
		} else {
			this.showCounter--;
		}

		if (this.showCounter > 0) {
			this.showSpinner = true;
			if (this.timeout == null) {
				this.timeout = setTimeout(() => { this.showSpinnerBlock = true; }, 250);
			}
		} else {
			this.showSpinner = false;
			this.showSpinnerBlock = false;
			if (this.timeout != null) {
				clearTimeout(this.timeout);
				this.timeout = null;				
			}
		}
	}
	public get show() {
		return this.showCounter > 0;
	}

	ngOnInit(): void {
		SpinnerComponent.instance = this;
	}
}
